import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import logger from '../utils/logger';
import { Link } from 'react-router-dom';

const MyProfilePage: React.FC = () => {
  const { user, signOut, getIdToken } = useAuth();
  const [apiResponse, setApiResponse] = useState<string>('');
  const [idToken, setIdToken] = useState<string | null>(null);

  useEffect(() => {
    if (user) {
      logger.debug('User is signed in on MyProfilePage:', user);
    } else {
      logger.debug('User is not signed in on MyProfilePage.');
    }
  }, [user]);

  const handleFetchProtectedApi = async () => {
    if (!user) {
      setApiResponse('Please sign in to test the API.');
      return;
    }
    try {
      const token = await getIdToken();
      if (!token) {
        setApiResponse('Could not get ID token.');
        return;
      }
      setIdToken(token); // Store the token for display or other uses
      setApiResponse('Protected API call successful (mocked). Token acquired.');
    } catch (error) {
      logger.error('Error fetching protected API:', error);
      setApiResponse(`Error: ${(error as Error).message}`);
    }
  };

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4 text-text-light">My Profile</h1>

      <div className="mb-6 p-4 border rounded-lg shadow-sm bg-background-light">
        <h2 className="text-xl font-semibold mb-2 text-text-light">Authentication Details</h2>
        {!user ? (
          <div className="space-x-2">
            <p className="text-text-light">You are not signed in.</p>
            <Link to="/signin" className="deriq-action-button">Go to Sign In Page</Link>
          </div>
        ) : (
          <div>
            <p className="text-text-light">Welcome, <span className="font-semibold">{user.name || user.email}</span>!</p>
            {user.avatarUrl && <img src={user.avatarUrl } alt="User" className="w-16 h-16 rounded-full my-2" />}
            <p className="text-text-light text-sm">UID: {user.uid}</p>
            <p className="text-text-light text-sm">Email Verified: {user.email ? 'Yes' : 'No'}</p>
            <button onClick={handleFetchProtectedApi} className="deriq-action-button mt-2 mr-2">Test Get ID Token</button>
            <button onClick={signOut} className="deriq-action-button-secondary mt-2">Sign Out</button>
            {idToken && 
              <p className="text-text-light mt-2 text-xs break-all">ID Token: 
              {JSON.stringify(idToken, null, 2)}
              </p>}
            {apiResponse && 
              <pre className="mt-2 p-2 bg-background-darker text-text-lighter rounded text-xs overflow-x-auto">
              {JSON.stringify(apiResponse, null, 2)}
              </pre>}
          </div>
        )}
      </div>
    </div>
  );
};

export default MyProfilePage;